import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWave"><Path d="M13 19H16V10.5H22V12.5H18V21H11V5H8V13H2V11H6V3H13V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWave;
